import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import * as echarts from "echarts";
import { getGuanqiaLostData2 } from '@/api/data';
import DataOptions from "../../../components/timeList/dataOptions.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
export default {
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    VxeTable: VxeTable
  },
  data: function data() {
    var h = this.$createElement;
    return {
      serverInfo: [],
      dataList: [],
      dateInfo: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        title: "日期",
        field: "date_str"
      }, {
        title: "新增角色",
        field: "new_role"
      }, {
        title: "第1关开始角色",
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return h("div", [h("div", [row.start_role_1]), h("div", ["(", row.start_ratio_1, "%)"])]);
          }
        }
      }, {
        title: "第1关通关角色",
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return h("div", [h("div", [row.win_role_1]), h("div", ["(", row.win_ratio_1, "%)"])]);
          }
        }
      }, {
        title: "第2关开始角色",
        slots: {
          default: function _default(_ref3) {
            var row = _ref3.row;
            return h("div", [h("div", [row.start_role_2]), h("div", ["(", row.start_ratio_2, "%)"])]);
          }
        }
      }, {
        title: "第2关通关角色",
        slots: {
          default: function _default(_ref4) {
            var row = _ref4.row;
            return h("div", [h("div", [row.win_role_2]), h("div", ["(", row.win_ratio_2, "%)"])]);
          }
        }
      }, {
        title: "第3关开始角色",
        slots: {
          default: function _default(_ref5) {
            var row = _ref5.row;
            return h("div", [h("div", [row.start_role_3]), h("div", ["(", row.start_ratio_3, "%)"])]);
          }
        }
      }, {
        title: "第3关通关角色",
        slots: {
          default: function _default(_ref6) {
            var row = _ref6.row;
            return h("div", [h("div", [row.win_role_3]), h("div", ["(", row.win_ratio_3, "%)"])]);
          }
        }
      }, {
        title: "第4关开始角色",
        slots: {
          default: function _default(_ref7) {
            var row = _ref7.row;
            return h("div", [h("div", [row.start_role_4]), h("div", ["(", row.start_ratio_4, "%)"])]);
          }
        }
      }, {
        title: "第4关通关角色",
        slots: {
          default: function _default(_ref8) {
            var row = _ref8.row;
            return h("div", [h("div", [row.win_role_4]), h("div", ["(", row.win_ratio_4, "%)"])]);
          }
        }
      }, {
        title: "第5关开始角色",
        slots: {
          default: function _default(_ref9) {
            var row = _ref9.row;
            return h("div", [h("div", [row.start_role_5]), h("div", ["(", row.start_ratio_5, "%)"])]);
          }
        }
      }, {
        title: "第5关通关角色",
        slots: {
          default: function _default(_ref10) {
            var row = _ref10.row;
            return h("div", [h("div", [row.win_role_5]), h("div", ["(", row.win_ratio_5, "%)"])]);
          }
        }
      }]
    };
  },
  methods: {
    onSearchBtn: function onSearchBtn() {
      var _this = this;
      var searchInfo = {
        sdate: this.dateInfo[0],
        edate: this.dateInfo[1],
        server_id: this.serverInfo
      };
      searchInfo.server_id = this.serverInfo;
      var _iterator = _createForOfIteratorHelper(searchInfo.server_id),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var serverId = _step.value;
          if (serverId == '0') {
            searchInfo.server_id = [];
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      getGuanqiaLostData2(searchInfo).then(function (res) {
        _this.dataList = res.data.list;
        _this.initChart();
      });
    },
    initChart: function initChart() {
      var chart = echarts.init(this.$refs.chart);
      var dateAry = [];
      var legendAry = ['新角色开始率', '第2关留存率', '第3关留存率', '第4关留存率', '第5关留存率', '第1关通关率', '第2关通关率', '第3关通关率', '第4关通关率', '第5关通关率'];
      var option = {
        xAxis: {
          type: 'category',
          data: dateAry
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legendAry
        },
        yAxis: {
          type: 'value'
        },
        series: []
      };
      for (var _i = 0, _legendAry = legendAry; _i < _legendAry.length; _i++) {
        var legend = _legendAry[_i];
        option.series.push({
          name: legend,
          data: [],
          type: 'line'
        });
      }
      var _iterator2 = _createForOfIteratorHelper(this.dataList.slice().reverse()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var data = _step2.value;
          dateAry.push(data.date_str);
          option.series[0].data.push(data.start_ratio_1);
          option.series[1].data.push(data.start_ratio_2);
          option.series[2].data.push(data.start_ratio_3);
          option.series[3].data.push(data.start_ratio_4);
          option.series[4].data.push(data.start_ratio_5);
          option.series[5].data.push(data.win_ratio_1);
          option.series[6].data.push(data.win_ratio_2);
          option.series[7].data.push(data.win_ratio_3);
          option.series[8].data.push(data.win_ratio_4);
          option.series[9].data.push(data.win_ratio_5);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      chart.setOption(option);
    }
  },
  mounted: function mounted() {
    this.onSearchBtn();
  }
};